import {BASE_TITLES} from './constants';
import {TypeAccountRoles} from './types/user-account.types';

export interface IRole {
  readonly label: string;
  readonly value: TypeAccountRoles;
}

export const roles: IRole[] = [
  {label: BASE_TITLES.company.base, value: TypeAccountRoles.CUSTOMER},
  {label: BASE_TITLES.manager.base, value: TypeAccountRoles.MANAGER},
  {label: BASE_TITLES.director.base, value: TypeAccountRoles.DIRECTOR},
  {label: BASE_TITLES.workers.base, value: TypeAccountRoles.WORKER},
  {label: BASE_TITLES.functionalAdmin.base, value: TypeAccountRoles.FUNCTIONAL_ADMIN},
  {label: BASE_TITLES.projectManager.base, value: TypeAccountRoles.PROJECT_MANAGER},
  {label: BASE_TITLES.admin.base, value: TypeAccountRoles.ADMIN},
];

export const mapWithRoleOptions = new Map();

roles.forEach((i) => {
  mapWithRoleOptions.set(i.value, i);
});

mapWithRoleOptions.set(TypeAccountRoles.VIEWER, {label: BASE_TITLES.guest.base, value: TypeAccountRoles.VIEWER});
